import DiamondTextBox from "../../componets/DiamondTextBox";
import Divider from "../../componets/Divider";
import servicesData from "../../data/cctvSurveillanceServices.json";

export default function Section3() {
  return (
    <div className="Section3">
      <DiamondTextBox data={servicesData} containerStyle="!p-[1%_0%_2%_0%]" boxStyle="p-[2%] w-full xs:w-[42%] md:w-[26%] xs:p-[1%]" />

      <Divider marginStyle="!mt-[1%]" />
    </div>
  );
}
